export const initialState = {
  filters: {},
  educationMaterials: [],
  educationMaterial: {},
  educationMaterialBySlug: {},
  editTranslation: {},
  loading: false
};
